import type { ChainTag } from "@umi/shared/chains";



// Thrown when a named contract is missing from chain configuration.
export class ContractNotConfiguredError extends Error {
  constructor(contractName: string, chain: ChainTag) {
    super(`Contract ${contractName} is not configured for chain ${chain}`);
    this.name = "ContractNotConfiguredError";
  }
}

// Thrown when a token contract uses an unsupported standard (e.g. for balance reads).
export class UnknownTokenStandardError extends Error {
  constructor(address: string) {
    super(`Unsupported token standard for token: ${address}`);
    this.name = "UnknownTokenStandardError";
  }
}

export class UnsupportedProviderError extends Error {
  constructor(provider: string) {
    super(`Unsupported provider: ${provider}`);
    this.name = "UnsupportedProviderError";
  }
}
